import { SimulationVariable } from '../simulation-variable';

export interface ParameterProvider {
  getAvailableParameters(): Array<SimulationVariable>;
  getAvailableParametricStudyParameters(): Array<SimulationVariable>;
}
export function isParameterProvider(pp: any): pp is ParameterProvider {
  return pp !== null && typeof (pp as ParameterProvider).getAvailableParameters === 'function';
}
